import { Mixins, Component } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import Breadcrumbs from '@/_components/breadcrumbs/breadcrumbs.vue'
@Component({
    inheritAttrs: false,
    components: { Breadcrumbs },
})
export default class AppToolbar extends Mixins<MixinInterface>() {
    get hasToolBar() {
        return this.isAuthenticated || this.$store.getters.token
    }

    get hasTemporaryMenu() {
        return this.viewType == 'mobile' || this.viewType == 'tablet'
    }

    get mobileDrawerState() {
        return this.$store.getters.mobileDrawerState
    }

    toggleMobileMenu() {
        this.$store.commit('toggleMobileDrawerState', !this.mobileDrawerState)
    }
}
